export interface TiposIncidentesVo {
  incidentes: Incidente[];
  ativo: boolean;
  padrao: boolean;
}

export interface Incidente {
  descricao: string;
  grupo: string;
  codigo: string;
}

export const emptyTiposIncidentes = (): TiposIncidentesVo => ({
  incidentes: [],
  ativo: true,
  padrao: true,
});

export const resetTiposIncidentes = (): TiposIncidentesVo => ({
  incidentes: [],
  ativo: false,
  padrao: false,
});

export const emptyIncidente = (): Incidente => ({
  descricao: '',
  grupo: '',
  codigo: '',
});
